/**
 * Kid Kelly Message System - Shows encouraging/narrative popups during gameplay
 */

export class KidKellyMessages {
  private popup: HTMLElement;
  private currentTimeout: number | null = null;

  constructor() {
    const element = document.getElementById('kidKellyPopup');
    if (!element) {
      throw new Error('Kid Kelly popup element not found');
    }
    this.popup = element;
  }

  public show(message: string, duration: number = 1800): void {
    // Clear any existing timeout
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
    }

    // Set message and show popup
    this.popup.textContent = message;
    this.popup.classList.add('show');

    // Hide after duration
    this.currentTimeout = window.setTimeout(() => {
      this.popup.classList.remove('show');
      this.currentTimeout = null;
    }, duration);
  }

  public hide(): void {
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
      this.currentTimeout = null;
    }
    this.popup.classList.remove('show');
  }

  // Predefined message types from original game
  public showWaveStart(waveNumber: number): void {
    this.show(`Wave ${waveNumber} approaching! Defend the chain! 🤝`);
  }

  public showWaveComplete(waveNumber: number): void {
    const messages = [
      `Wave ${waveNumber} defended! The chain grows stronger! 🤝`,
      `The people are safe! Wave ${waveNumber} complete! 🇺🇸`,
      `Unity prevails! Wave ${waveNumber} conquered! ✨`,
      `Hope restored! Wave ${waveNumber} cleared! 💫`
    ];
    const randomMessage = messages[Math.floor(Math.random() * messages.length)];
    this.show(randomMessage);
  }

  public showPowerUpActivated(powerUpName: string): void {
    const messages: Record<string, string> = {
      'neon_shield': '🛡️ HOPE SHIELD ACTIVATED! 🛡️',
      'rapid_shot': '⚡ RAPID UNITY FIRE! ⚡',
      'extra_life': '❤️ EXTRA HANDS JOINED! ❤️',
      'score_mult': '💎 CHAIN MULTIPLIER! 💎',
      'bass_boost': '🔊 UNITY POWER BOOST! 🔊',
      'tempo_boost': '✨ HOPE AMPLIFIED! ✨',
      'double_chain': '🤝 DOUBLE CHAIN MODE! 🤝',
      'triple_shot': '🌟 TRIPLE HOPE SPREAD! 🌟',
      'starburst': '💥 UNITY BURST! 💥',
      'time_freeze': '❄️ TIME FREEZE - PROTECT THE CHAIN! ❄️',
      'auto_collect': '🧲 CHAIN MAGNET ENGAGED! 🧲'
    };

    const message = messages[powerUpName] || `🤝 ${powerUpName} activated! 🤝`;
    this.show(message);
  }

  public showMidWaveEncouragement(): void {
    const messages = [
      "Keep defending! The chain needs you! 🤝",
      "America is counting on you! 💪",
      "Protect the unity! 🌟",
      "Keep hope alive! ✨",
      "Stay strong, the chain depends on you! 🇺🇸",
      "Defend the people! 💫",
      "The chain must hold! 🔗",
      "Unity is our strength! 🎯"
    ];
    const randomMessage = messages[Math.floor(Math.random() * messages.length)];
    this.show(randomMessage, 2000);
  }

  public showGameOver(): void {
    this.show("Game Over! But hope lives on... 🤝", 5000);
  }

  public showVictory(): void {
    this.show("Victory! Hands Across America complete! 🇺🇸✨", 5000);
  }
}
